<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'TeaserCard',
    props: {
      teaser: Object,
    },
  }
</script>
